export function contactTimelineFilterParams(filters: Record<string, unknown>): URLSearchParams {
  const params = new URLSearchParams({ limit: "100" });

  for (const [key, value] of Object.entries(filters)) {
    const filterValue = String(value ?? "").trim();

    if (filterValue) {
      params.set(key, filterValue);
    }
  }

  return params;
}
